import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { AssetUrlPipe } from '../../pipes/asset-url.pipe';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrl: './confirmation-dialog.component.scss',
    imports: [CdkScrollable, MatDialogContent, AssetUrlPipe]
})
export class ConfirmationDialogComponent {
  dialogData: any;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.dialogData = this.data;
  }

  close(value = false) {
    this.dialogRef.close(value);
  }

  send(text: string) {
    this.dialogRef.close(text);
  }
}
